import apiClient from "services/ApiClient";
import { API_ROUTES } from "definitions/constants/routeConstants";
import type { TaskGridResponse, TaskGridPreferences, TaskGridPreferencesPatch } from "./types";

const ROUTES = API_ROUTES.peopleTeam.taskGrid;

export async function fetchTaskGrid(): Promise<TaskGridResponse> {
  return apiClient.get<TaskGridResponse>(ROUTES.base);
}

export async function fetchTaskGridPreferences(): Promise<TaskGridPreferences> {
  return apiClient.get<TaskGridPreferences>(ROUTES.preferences);
}

const ID_ARRAY_KEYS = ["hiddenJourneyIds", "hiddenTemplateIds", "journeyOrder", "templateOrder"] as const;

// Backend stores ids as integers; drag handlers and merge helpers work in
// strings (prefix-id-safe). Coerce at the boundary so call sites can pass
// either shape without `as unknown as number[]` casts.
function coercePatch(patch: TaskGridPreferencesPatch): Record<string, unknown> {
  const out: Record<string, unknown> = { ...patch };
  ID_ARRAY_KEYS.forEach((key) => {
    const value = patch[key];
    if (value !== undefined) out[key] = value.map((v) => Number(v));
  });
  return out;
}

export async function updateTaskGridPreferences(patch: TaskGridPreferencesPatch): Promise<TaskGridPreferences> {
  return apiClient.patch<TaskGridPreferences>(ROUTES.preferences, coercePatch(patch));
}
